import * as ContractModule from 'Modules/ContractModule';
import * as ActionTypes from './EnumTypes/ActionEnumTypes';
import {store} from '../Store';
import {RootState} from 'Redux/Reducers/_RootReducer';
import {
    GetContractHistorySuccessAction,
    GetContractListSuccessAction,
    GetContractListWithFiltersSuccessAction,
    SetActive, SetCurrentContractVin
} from "Redux/Actions/Models/ContractActionModel";
import * as InfinityTableModule from "Modules/InfinityTableModule";
import {Types} from "Modules/ContractModule";
import ChangeOffDateBody = Types.ChangeOffDateBody;
import EditContractBody = Types.EditContractBody;
import {EnumTypes as ErrorEnumType} from "Models/EnumTypes/ErrorEnumTypes";
import * as ErrorActions from './ErrorActions';

/**
 * Klasa kreatora akcji dla umów
 *
 * @export
 * @class ContractActions
 */
export class ContractActions {
    /**
     * Thank odpowiedzialny za pobranie listy zleceń montażu z serwera
     *
     * @static
     * @param {URLSearchParams} [queryParams]
     * @param {boolean} [filterQuery]
     * @returns {Function}
     * @memberOf ContractActions
     */
    public static getContractList(queryParams?: URLSearchParams, filterQuery?: boolean): Function {
        return async dispatch => {
            try {
                const response = await ContractModule.Connector.getContractList(queryParams);
                const contractList = response.data.results;
                const totalCount = response.data.totalCount;

                if (filterQuery) {
                    dispatch(this.getContractListWithFiltersSuccessAction(contractList));
                } else {
                    dispatch(this.getContractListSuccessAction(contractList));
                }

                const contractListNewLength = (store.getState() as RootState).contractStore.contractList.length;
                dispatch(InfinityTableModule.Actions.setInfinityTableAllCounts(contractListNewLength, totalCount));

            } catch (err) {
                // console.log('error action', err);
            }
        };
    }

    /**
     * Thank odpowiedzialny za pobranie historii edycji dla danego contractNumber
     *
     * @static
     * @param {number} id
     * @returns {Function}
     * @memberOf ContractActions
     */
    public static getContractHistory(id?: number): Function {
        return async dispatch => {
            try {
                const response = await ContractModule.Connector.getContractHistory(id);
                dispatch(this.getContractHistorySuccessAction(response.data.results));
            } catch (err) {
                // console.log('error action', err);
            }
        };
    }

    public static changePlannedEndDate(contractId: number, formData: ChangeOffDateBody): Function {
        return async dispatch => {
            try {
                const response = await ContractModule.Connector.putPlannedEndDate(contractId, formData);
            } catch (err) {
                // console.log('error action', err);
            }
        };
    }

    public static editContract(formData: EditContractBody): Function {
        return async dispatch => {
            try {
                await ContractModule.Connector.editContract(formData);
                dispatch(ErrorActions.setNewsForMoment({
                    type: ErrorEnumType.NewsType.SUCCESS,
                    message: 'Pomyślnie zmieniono numer umowy'
                }));
            } catch (err) {
                dispatch(ErrorActions.setNewsForMoment({
                    type: ErrorEnumType.NewsType.ERROR,
                    message: 'Błąd przy zmianie numer umowy'
                }));
            }
        };
    }

    /**
     * Generator akcji powiązany z thank getContractList.
     * Wykonywany gdy pobranie danych poprzez infinity scroll się powiodło
     *
     * @private
     * @static
     * @param {Array<ContractModule.Types.ContractSingleDto>} contractList
     * @returns {GetContractListSuccessAction}
     * @memberOf ContractActions
     */
    private static getContractListSuccessAction(contractList: Array<ContractModule.Types.ContractSingleDto>): GetContractListSuccessAction {
        return {
            type: ActionTypes.CONTRACT.GET_CONTRACT_LIST_SUCCESS,
            payload: {
                contractList
            }
        };
    }

    /**
     * Generator akcji powiązany z thank getContractList.
     * Wykonywany gdy pobranie danych Z FILTRAMI się powiodło
     *
     * @private
     * @static
     * @param {Array<ContractModule.Types.ContractSingleDto>} contractList
     * @returns {GetContractListWithFiltersSuccessAction}
     * @memberof ContractActions
     */
    private static getContractListWithFiltersSuccessAction(contractList: Array<ContractModule.Types.ContractSingleDto>): GetContractListWithFiltersSuccessAction {
        return {
            type: ActionTypes.CONTRACT.GET_CONTRACT_LIST_WITH_FILTERS_SUCCESS,
            payload: {
                contractList
            }
        };
    }

    /**
     * Generator akcji powiązany z thank getContractHistory.
     *
     * @private
     * @static
     * @param {Array<ContractModule.Types.ContractHistoryDto>} contractHistory
     * @returns {GetContractListSuccessAction}
     * @memberOf ContractActions
     */
    private static getContractHistorySuccessAction(contractHistory: Array<ContractModule.Types.ContractHistoryDto>): GetContractHistorySuccessAction {
        return {
            type: ActionTypes.CONTRACT.GET_CONTRACT_HISTORY_SUCCESS,
            payload: {
                contractHistory
            }
        };
    }

    /**
     * Generator akcji zwraca akcje ustawiającą aktywną umowę
     *
     * @static
     * @param {string} contractNumber
     * @returns {SetActive}
     * @memberOf ContractActions
     */
    public static setActive(contractNumber: string): SetActive {
        return {
            type: ActionTypes.CONTRACT.SET_ACTIVE,
            payload: {
                contractNumber
            }
        };
    }

    /**
     * Generator akcji zwraca akcję ustawiąjącą VIN w aktualnie wybranej umowie
     *
     * @static
     * @param {string} currentVin
     * @returns {SetCurrentContractVin}
     * @memberOf ContractActions
     */
    public static setCurrentContractVin(currentVin: string): SetCurrentContractVin {
        return {
            type: ActionTypes.CONTRACT.SET_CURRENT_CONTRACT_VIN,
            payload: {
                currentVin
            }
        };
    }
}



// WEBPACK FOOTER //
// ./src/Redux/Actions/ContractActions.ts